import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "update-theme",
  initialState: initialState,
  reducers: {
    initUploadThemeImage: () => {
      return { ...initialState };
    },
    startUploadThemeImage: (state) => {
      state.loading = true;
    },
    successUploadThemeImage: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUploadThemeImage: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initUploadThemeImage,
  startUploadThemeImage,
  successUploadThemeImage,
  errorUploadThemeImage,
} = dataSlice.actions;

export default dataSlice.reducer;
